import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 过户状态-卖方视角
 */
class SellerTransferType extends UltMeta {
    DRAFT = new Meta(0, "草稿");
    // 卖方提交
    IN_REVIEW = new Meta(1, "审核中");
    // 驳回
    REJECTED = new Meta(2, "已驳回");
    // 卖方待核实
    PENDING_VERIFICATION = new Meta(3, "待核实");
    // 买方待核实 此时对于卖方是核实中
    VERIFYING = new Meta(4, "核实中");
    // 买卖双方已核实
    VERIFIED = new Meta(5, "已核实");
    // 供应链签署中 ---- 供应链签署中间状态 -- 不在筛选条件和列表状态中体现
    SIGNING = new Meta(6, "已核实");
    // 供应链签署完成
    TRANSFER_COMPLETED = new Meta(7, "过户完成");
    // 作废中
    INVALIDING = new Meta(8, "作废中");
    // 已作废
    INVALID = new Meta(9, "已作废");
}

export const SELLER_TRANSFER_TYPE = new SellerTransferType();

/**
 * 过户状态-客户端-筛选条件使用
 */
class CustomerTransferTypeOnSearch extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    IN_REVIEW = new Meta(2, "审核中");
    REJECTED = new Meta(3, "已驳回");
    PENDING_VERIFICATION = new Meta(4, "待核实");
    VERIFYING = new Meta(5, "核实中");
    VERIFIED = new Meta(6, "已核实");
    TRANSFER_COMPLETED = new Meta(7, "过户完成");
    // 作废中
    INVALIDING = new Meta(8, "作废中");
    // 已作废
    INVALID = new Meta(9, "已作废");
}

export const CUSTOMER_TRANSFER_TYPE_ON_SEARCH = new CustomerTransferTypeOnSearch();

/**
 * 过户状态-供应链
 */
class AdminTransferType extends UltMeta {
    // 卖方提交--供应链审核
    IN_REVIEW = new Meta(1, "待审核");
    // 卖方审核中
    PENDING_VERIFICATION = new Meta(3, "核实中");
    // 买方核实中
    VERIFYING = new Meta(4, "核实中");
    // 买卖方已核实
    VERIFIED = new Meta(5, "已核实");
    // 供应链签署中 ---- 供应链签署中间状态 -- 不在筛选条件和列表状态中体现
    SIGNING = new Meta(6, "已核实");
    // 供应链签署完成
    TRANSFER_COMPLETED = new Meta(7, "过户完成");
    // 作废中
    INVALIDING = new Meta(8, "作废中");
    // 已作废
    INVALID = new Meta(9, "已作废");
}

export const ADMIN_TRANSFER_TYPE = new AdminTransferType();

/**
 * 过户状态-供应链-筛选条件使用
 */
class AdminTransferTypeOnSearch extends UltMeta {
    IN_REVIEW = new Meta(2, "审核中");
    PENDING_VERIFICATION = new Meta(2, "核实中");
    VERIFIED = new Meta(3, "已核实");
    TRANSFER_COMPLETED = new Meta(4, "过户完成");
    INVALIDING = new Meta(5, "作废中");
    INVALID = new Meta(6, "已作废");
}

export const ADMIN_TRANSFER_TYPE_ON_SEARCH = new AdminTransferTypeOnSearch();

/**
 * 过户状态-管理后台-筛选条件使用
 */
class BackEndTransferTypeOnSearch extends UltMeta {
    IN_REVIEW = new Meta(1, "审核中");
    PENDING_VERIFICATION = new Meta(2, "核实中");
    VERIFIED = new Meta(3, "已核实");
    TRANSFER_COMPLETED = new Meta(4, "过户完成");
    INVALIDING = new Meta(5, "作废中");
    INVALID = new Meta(6, "已作废");
    // 7已驳回 -> 已驳回 （后台管理）
    OVERRULE = new Meta(7, "已驳回");
}

export const BACK_END_TRANSFER_TYPE_ON_SEARCH = new BackEndTransferTypeOnSearch();

/**
 * 客户端-过户类型
 */
class TransferType extends UltMeta {
    BUY_TRANSFER = new Meta(0, "买入过户");
    SELL_TRANSFER = new Meta(1, "卖出过户");
}

export const TRANSFER_TYPE = new TransferType();

/**
 * 保存类型
 * */
class TransferSaveType extends UltMeta {
    SAVE_TO_DRAFT = new Meta(1, "保存为草稿");
    SAVE_AND_COMMIT = new Meta(2, "保存并提交");
}
export const TRANSFER_SAVE_TYPE = new TransferSaveType();

/**
 * 客户端-发送验证码的类型
 */
class TransferSendType extends UltMeta {
    SELLER = new Meta(1, "卖方");
    BUYER = new Meta(2, "买方");
}

export const TRANSFER_SEND_TYPE = new TransferSendType();

/**
 * 供应链过户签署方式
 */
class transferSignMode extends UltMeta {
    ONLINE = new Meta(0, "线上");
    OFFLINE = new Meta(1, "线下");
}
export const TRANSFER_SIGN_MODE = new transferSignMode();

/**
 * 过户作废发起方
 * */
class TransferInvalidInitiator extends UltMeta {
    BUYER = new Meta(1, "买方");

    SELLER = new Meta(2, "卖方");

    WAREHOUSE = new Meta(3, "仓库方");
}
export const TRANSFER_INVALID_INITIATOR = new TransferInvalidInitiator();

/**
 * 作废状态
 * */
class TransferInvalidState extends UltMeta {
    UNSIGNED = new Meta(1, "未签署/未确认");
    SIGNED = new Meta(2, "签署完成/已确认");
    REJECT = new Meta(3, "已驳回");
}
export const TRANSFER_INVALID_STATE = new TransferInvalidState();
